import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-members",
  "use": "icon-soc-l1-members-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-members\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M288 224h448a48 48 0 0 1 48 48v480a48 48 0 0 1-48 48H288a48 48 0 0 1-48-48V272a48 48 0 0 1 48-48zm64 96v64h320v-64H352zm80 160a96 96 0 1 1 0 192 96 96 0 0 1 0-192zm-128 256c0-64 96-96 160-96s160 32 160 96v48H304v-48z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-members.svg
// module id = LNum
// module chunks = 478